import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@shared/modules/material.module';
import { AdminRoutes} from './admin-layout-routing.module';

import { RouterModule } from '@angular/router';
import { ParametriaRoutes } from '../parametria-layout/parametria-layout-routing.module';

@NgModule({
  declarations: [
  ],
  imports: [
    MaterialModule,    
    CommonModule,
    RouterModule.forChild(AdminRoutes)
  ],
  exports:[
  ]
})
export class AdminLayoutModule { }
